var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartB9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M5 8.289 1.453 4.703l-.29-.293A2.3 2.3 0 0 1 .5 2.79c0-.61.24-1.192.664-1.621A2.24 2.24 0 0 1 2.759.5c.598 0 1.172.24 1.596.669l.29.293.355.36.355-.36.29-.293A2.24 2.24 0 0 1 7.241.5c.597 0 1.171.24 1.595.669.425.429.664 1.012.664 1.62 0 .61-.24 1.192-.664 1.621l-.29.293z"
})));
export default SvgIconHeartB9;